<template>
  <tbody>
    <tr v-for="(food, index) in foods" :key="food.id">
      <th scope="row">{{ index + 1 }}</th>
      <td>{{ food.name }}</td>
      <td>
        <p v-if="role !== 'admin'">{{ food.status }}</p>
        <select
          name=""
          id=""
          v-if="role === 'admin'"
          @change="changeStatus($event, food.id)"
          v-model="food.status"
        >
          <!-- dikasih vmodel -->
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="archived">Archived</option>
        </select>
      </td>
      <td>{{ food.description }}</td>
      <td>{{ food.price }}</td>
      <td>
        <img :src="food.imgUrl" alt="" width="200" />
      </td>
      <td>
        <div v-if="check(food.authorId)">
          <Button
            type="button"
            class="btn btn-secondary detail-food"
            buttonText="Detail"
            @getFoodDetail="getFoodDetail(food)"
          ></Button>

          <Button
            type="button"
            class="btn btn-secondary edit-food green"
            buttonText="Edit"
            @goToFormEdit="goToFormEdit(food)"
          >
          </Button>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import Button from "../components/button.vue";
import axios from "../apis/server";
export default {
  name: "RowTable",
  components: {
    Button,
  },
  methods: {
    getFoodDetail(food) {
      this.$emit("getFoodDetail", food);
    },
    goToFormEdit(food) {
      this.$emit("toEdit", food);
    },
    changeStatus(e, id) {
      let status = {
        status: e.target.value,
      };
      axios({
        url: `/foods/${id}`,
        method: "PATCH",
        headers: { access_token: localStorage.getItem("access_token") },
        data: status,
      })
        .then(({ data }) => {
          console.log(data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    check(foodAuthorId) {
      if (this.role !== "admin") {
        if (foodAuthorId !== this.userId) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      foods: [],
      status: "",
      userId: "",
      role: "",
    };
  },

  created() {
    axios({
      url: "/foods",
      method: "GET",
      headers: { access_token: localStorage.getItem("access_token") },
    })
      .then(({ data }) => {
        this.foods = data;
      })
      .catch((err) => {
        console.log(err);
      });
    axios({
      url: "/userdata",
      method: "GET",
      headers: { access_token: localStorage.getItem("access_token") },
    })
      .then(({ data }) => {
        this.role = data.role;
        this.userId = data.id;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style>
</style>